<div class="modal-content" id="task-record-list-approve-state-dialog-content">
  <div class="modal-header">
    <p class="modal-title"><strong>{{ 'TASK_LIST_DOWNLOAD_ALL_FILES' | translate }}</strong></p>
    <button type="button" class="close" (click)="close(false)" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form (ngSubmit)="tryDownloadFiles()" #f="ngForm" id="form"
        [formGroup]="formGroup" novalidate>
    <div class="modal-body">
      <mat-dialog-content style="overflow:visible">
        <div>
          <label>{{
              'TASK_LIST_DOWNLOAD_ALL_FILES_MESSAGE' | translate: {
                count: data.ids.size
              }
            }}</label>
        </div>
        <div>
          <div class="form-group row"
               [ngClass]="{ 'has-danger': hasLocalFieldError('fileTypes')}">
            <div class="col-md-4">
              <label class="col-form-label mw-100 form-control-label required-field-label">
                {{ 'TASK_LIST_DOWNLOAD_ALL_FILES_TYPES'|translate }}
              </label>
            </div>
            <div class="col-md-8">
              <angular2-multiselect [data]="fileTypes" [settings]="fileTypeDropdownSettings"
                                    class="form-control"
                                    [ngClass]="{ 'form-control-danger': hasLocalFieldError('fileTypes') }"
                                    [(ngModel)]="model.fileTypes"
                                    (onSelect)="fileTypeSelected([$event])"
                                    (onDeSelect)="fileTypeDeSelected([$event])"
                                    (onSelectAll)="fileTypeSelected($event)"
                                    (onDeSelectAll)="fileTypeDeSelected($event)"
                                    formControlName="fileTypes">
              </angular2-multiselect>
              <div class="form-control-feedback"
                   *ngIf="hasLocalFieldError('fileTypes')">
                {{ 'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate }}
              </div>
            </div>
          </div>
          <div class="form-group row"
               *ngIf="formFields.length > 0 && model.formFieldsEnabled"
               [ngClass]="{ 'has-danger': hasLocalFieldError('formFields')}">
            <div class="col-md-4">
              <label class="col-form-label mw-100 form-control-label required-field-label"
              [ngClass]="{'required-field-label': model.formFieldsEnabled}">
                {{ 'TASK_LIST_DOWNLOAD_ALL_FORM_FIELDS'|translate }}
              </label>
            </div>
            <div class="col-md-8">
              <angular2-multiselect [data]="formFields" [settings]="formFieldDropdownSettings"
                                    class="form-control"
                                    [ngClass]="{ 'form-control-danger': hasLocalFieldError('formFields') }"
                                    [(ngModel)]="model.formFields"
                                    formControlName="formFields">
              </angular2-multiselect>
              <div class="form-control-feedback"
                   *ngIf="hasLocalFieldError('formFields')">
                {{ 'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate }}
              </div>
            </div>
          </div>
        </div>
      </mat-dialog-content>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary-green" (click)="close(false)">
        {{ 'COMMON_BUTTON_CANCEL' | translate }}
      </button>
      <button type="button" class="btn btn-primary-green"
              id="task-record-list-approve-state-save"
              [ladda]="loading" [disabled]="loading"
              (click)="tryDownloadFiles()">{{
          'COMMON_BUTTON_DOWNLOAD' |
            translate
        }}
      </button>
    </div>
  </form>
</div><!-- /.modal-content -->
